<template>
<div>
<CashReceipt/>

</div>
</template>
<script>
import CashReceipt from "../../components/Financial/CashReceipt.vue";

export default {
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  components: {
   CashReceipt
  },
  data() {
    return {
      content: ''
    };
  },
  created() {

  }
};
</script>

<style>


</style>